import { environment } from './environment';

export const endpoint = environment.STRAPI_GRAPHQL_API_URI;
export const fetchParams = {
  headers: {
    Authorization: `Bearer ${environment.STRAPI_API_TOKEN}`,
    'Content-Type': 'application/json'
  }
};
